var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BtnToggle',{class:{ active: _vm.value },attrs:{"title":_vm.$t('engine.manageText.modalWidget.tooltip.align.lblLift', _vm.languageEngine)},on:{"click":_vm.onClick}},[_c('i',{staticClass:"far fa-align-left"})])}
var staticRenderFns = []

export { render, staticRenderFns }